import React from 'react';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import SZLTDTO from '../../../../dto/SZLTDTO';
import { RegistryNumberInput } from '../RegistryNumberInput';
import { PROCEDURE_TYPE } from '../../../../configs';
import AddressInput from '../../../../components/fields/Address/AddressInput';

export default function ApplicationSzltForm(props) {
  const {
    prefix, formMeta, control, numberHelperAction = _ => {
    }, procedure, labelPrefix, getValues = () => {}, setValue = () => {},
  } = props;

  const DTO = new SZLTDTO();
  const attributes = DTO.getAttributesByName();
  return (
    <>
      {![PROCEDURE_TYPE.PROCEDURE_1228_1].includes(procedure) ? (
        <>
          <div className="f4">Номер в реестре СЗЛТ</div>
          <Row className="row-cols-1">
            <RegistryNumberInput
              formMeta={formMeta}
              getValues={getValues}
              numberHelperAction={numberHelperAction}
              labelPrefix={labelPrefix}
              setValue={setValue}
              procedure={procedure}
              control={control}
              prefix={prefix}
            />
          </Row>
          {/* <Row className="row-cols-2"> */}
          {/*  <FieldDTOWithCol */}
          {/*    control={control} */}
          {/*    formMeta={formMeta} */}
          {/*    type="text" */}
          {/*    component={DateTimePicker} */}
          {/*    hideTime */}
          {/*    changeFormat="YYYY-MM-DD" */}
          {/*    dtoObject={attributes.effective_date} */}
          {/*    disabled */}
          {/*    variant="material" */}
          {/*    withLabel */}
          {/*    namePrefix={prefix} */}
          {/*  /> */}
          {/*  <FieldDTOWithCol */}
          {/*    control={control} */}
          {/*    formMeta={formMeta} */}
          {/*    type="text" */}
          {/*    component={DateTimePicker} */}
          {/*    hideTime */}
          {/*    disabled */}
          {/*    changeFormat="YYYY-MM-DD" */}
          {/*    dtoObject={attributes.expiration_date} */}
          {/*    variant="material" */}
          {/*    withLabel */}
          {/*    namePrefix={prefix} */}
          {/*  /> */}
          {/* </Row> */}
          <div className="mb-3" />
        </>
      ) : null }
      { procedure === PROCEDURE_TYPE.PROCEDURE_1228_1 ? (
        <>
          <div className="mb-3" />
          <div className="f4">Сведения о СЗЛТ</div>
          <Row className="row-cols-1">
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={TextInputWithLabel}
              dtoObject={attributes.order_receiving_methods}
              // disabled={procedure === PROCEDURE_TYPE.PROCEDURE_1228_3}
              variant="material"
              namePrefix={prefix}
            />
          </Row>
          <div className="mb-3" />
          <div className="f4">Осуществление деятельности службы заказа предполагается с использованием ИТС &#34;Интернет&#34;</div>
          <Row className="row-cols-1">
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={TextInputWithLabel}
              dtoObject={attributes.web_site}
              // disabled={procedure === PROCEDURE_TYPE.PROCEDURE_1228_3}
              variant="material"
              namePrefix={prefix}
            />
          </Row>
          <Row className="row-cols-1">
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={AddressInput}
              dtoObject={attributes.database_address}
              variant="material"
              namePrefix={prefix}
            />
          </Row>
          <div className="mb-3" />
          <div className="f4">Адреса мест фактического расположения технических средств, используемых для получения, хранения, обработки и передачи заказов ЛТ</div>
          <Row className="row-cols-1">
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={AddressInput}
              dtoObject={attributes.server_address}
              variant="material"
              namePrefix={prefix}
            />
          </Row>
          <div className="mb-3" />
          <div className="f4">Наименования программ для электронных вычислительных машин</div>
          <Row className="row-cols-1">
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={TextInputWithLabel}
              dtoObject={attributes.software_names}
              variant="material"
              namePrefix={prefix}
            />
          </Row>
        </>
      ) : null }
    </>
  );
}
